const state = {
    performance_list :''
};

const mutations = {
     set_performance_list(state,val ){
         state.performance_list = val;
     }
};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
